// extracted by mini-css-extract-plugin
export default {"image":"UW-z","loaded":"VW-z"};